module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/report_icon-b41abc1f7a3ca3105fef7730a15bb220.png";